import {Box, Button, Grid, IconButton, Typography, useTheme} from "@mui/material";
import React from "react";
import {useOrder} from "../../context/order";
import {B2Site} from "../../data/client.gen";
import {useLocalization} from "../../i18n";
import {applyDiscountReduction} from "../../order-utils";
import {DisplayCurrency} from "../../utils";

import BackIcon from "../../assets/long-arrow-alt-left.svg";

interface OrderNavProps {
	site: B2Site;
	onBack?: () => void;
	onNext?: () => void;
	disabled?: boolean;
	actionLabel?: string;
}

export function OrderNav({site, onBack, onNext, disabled, actionLabel}: OrderNavProps) {
	const {currency} = site;
	const theme = useTheme();
	const {t} = useLocalization();
	const {order: {discount: {data}}, price} = useOrder();

	return (
		<Box
			mt={2}
			py={1}
			position="sticky"
			bottom={0}
			bgcolor="background.default"
		>
			<Grid
				container
				justifyContent="flex-end"
				spacing={2}
			>
				{onBack !== undefined && (
					<Grid
						item
						xs
					>
						<Box display={{xs: "none", sm: "block"}}>
							<IconButton
								sx={{
									fontSize: "1.4em",
									color: theme.palette.primary.contrastText,
								}}
								onClick={onBack}
							>
								<BackIcon style={{width: "0.875em", height: "1em"}} />
							</IconButton>
						</Box>
					</Grid>
				)}
				{(onBack !== undefined && price !== undefined) && (
					<Grid
						item
						xs="auto"
					>
						<Typography
							variant="body2"
							sx={{
								lineHeight: "1em",
								color: theme.palette.primary.contrastText,
							}}
						>
							<strong>{t("orders.total")}</strong>
						</Typography>
						<Typography
							variant="h3"
							color="pirmary"
							sx={{
								m: 0,
								lineHeight: "1em",
							}}
						>
							{currency} <DisplayCurrency amount={applyDiscountReduction(data, price)} />
						</Typography>
					</Grid>
				)}
				{onNext !== undefined && (
					<Grid
						item
						xs="auto"
					>
						<Box
							borderRadius="4px"
							bgcolor="primary.main"
						>
							<Button
								disabled={disabled}
								color="primary"
								variant="contained"
								disableElevation
								sx={theme => ({
									fontSize: "1.25em",
								})}
								onClick={onNext}
							>
								{actionLabel || t("actions.next")}
							</Button>
						</Box>
					</Grid>
				)}
			</Grid>
		</Box>
	);
}
